import { jsPDF } from "jspdf";
import "jspdf-autotable";
import logo from "../assests/BEFLogo.png";
import { toast } from "react-toastify";
import html2canvas from "html2canvas";
import { convertUtcToIstDateOnly } from "./TimeUtils";

  const generateCommonHeaderAndFooter = (
    doc,
    pageWidth,
    topMargin,
    leftMargin,
    rightMargin,
    bottomMargin
  ) => {
    let y = topMargin;
    const logoWidth = 20;
    const logoHeight = 20;
    doc.addImage(logo, "JPEG", leftMargin, y, logoWidth, logoHeight);
    doc.link(leftMargin, y, logoWidth, logoHeight, {
      url: "https://hkdigiverse.com",
    });
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    const textX = leftMargin + logoWidth + 5;
    doc.setTextColor("#E96D22");
    const bharatText = "BHARAT";
    doc.text(bharatText, textX, y + 10);
    const bharatWidth = doc.getTextWidth(bharatText);
    doc.setTextColor(0, 0, 255);
    const examText = "EXAM";
    doc.text(examText, textX + bharatWidth + 3, y + 10);
    const examWidth = doc.getTextWidth(examText);
    doc.setTextColor(0, 128, 0);
    const festText = "FEST";
    doc.text(festText, textX + bharatWidth + examWidth + 6, y + 10);
    const festWidth = doc.getTextWidth(festText);
    doc.link(textX, y + 8, bharatWidth, 10, { url: "https://hkdigiverse.com" });
    doc.link(textX + bharatWidth + 5, y + 8, examWidth, 10, {
      url: "https://hkdigiverse.com",
    });
    doc.link(textX + bharatWidth + examWidth + 10, y + 8, festWidth, 10, {
      url: "https://hkdigiverse.com",
    });
    const easyText = "LEARN AND EARN";
    const easyTextY = y + 16;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(easyText, textX, easyTextY);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    const address = [
      "S-251, Angel Business Center, near Sudama Chowk,",
      "Mota Varachha, Surat, Gujarat - 394101",
    ];
    address.forEach((line, index) => {
      doc.text(line, pageWidth - rightMargin, y + 5 + index * 6, {
        align: "right",
      });
    });

    y += 6 * address.length + 6;
    doc.setFont("helvetica", "bold");
    doc.text("Phone: +91 93279 97744", pageWidth - rightMargin, y, {
      align: "right",
    });
    y += 5;
    doc.line(leftMargin, y, pageWidth - rightMargin, y);

    const footerY = doc.internal.pageSize.height - bottomMargin;
    doc.setFontSize(10);
    doc.text("Email: ask@bharatexamfest.com", leftMargin, footerY);

    const poweredByText = "Powered By: HK Digiverse & IT Consultancy";
    doc.text(poweredByText, pageWidth - rightMargin, footerY, { align: "right" });
    const poweredByX = pageWidth - rightMargin - doc.getTextWidth(poweredByText);
    doc.link(poweredByX, footerY - 2, doc.getTextWidth(poweredByText), 10, {
      url: "https://hkdigiverse.com/",
    });
    const pageCount = doc.internal.getNumberOfPages();
    doc.text(`${pageCount}`, pageWidth / 2, footerY, { align: "center" });
    return { headerBottomY: y + 10, footerTopY: footerY - 5 };
  };
  export const onExportDetails = (userFields) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const margin = 8;
    const { headerBottomY } = generateCommonHeaderAndFooter(
      doc,
      pageWidth,
      margin,
      margin,
      margin,
      margin
    );
    let nextY = headerBottomY || margin;
    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.text("Student Details", pageWidth / 2, nextY, { align: "center" });
    nextY += 8;
    const tableData = userFields
      .filter((field) => field.value)
      .map((field) => [field.label, field.value]);

    doc.autoTable({
      startY: nextY,
      head: [["Field", "Value"]],
      body: tableData,
      theme: "grid",
      headStyles: {
        fillColor: "#124699",
        textColor: "#fff",
        fontStyle: "bold",
        cellPadding: 5,
      },
      bodyStyles: {
        fillColor: "#f5f5f5",
        textColor: "#000",
        fontSize: 10,
        cellPadding: 4,
      },
      alternateRowStyles: {
        fillColor: "#fff",
      },
      margin: { top: 10, left: margin, right: margin },
    });

    doc.save("student_details.pdf");
  };
export const exportToTablePDF = ({
  tableName,
  data,
  selectedStudents,
  headersConfig,
  pdfName,
}) => {
  const selectedData =
    selectedStudents && selectedStudents?.length > 0
      ? data.filter((row) => selectedStudents.includes(row._id))
      : data;

  if (selectedData.length === 0) {
    toast.warn("No data selected for export!", {
      autoClose: 2000,
      pauseOnHover: false,
    });
    return;
  }

  const doc = new jsPDF("landscape");
  const pageWidth = doc.internal.pageSize.width;
  const topMargin = 7;
  const leftMargin = 15;
  const rightMargin = 15;
  const bottomMargin = 10;
  let pageNumber = 1;

  const { headerBottomY } = generateCommonHeaderAndFooter(
    doc,
    pageWidth,
    topMargin,
    leftMargin,
    rightMargin,
    bottomMargin,
    pageNumber
  );
  doc.setFontSize(18);
  doc.setFont("helvetica", "bold");
  doc.text(tableName, pageWidth / 2, headerBottomY + 2, { align: "center" });
  const headers = [headersConfig?.map((header) => header.label)];
  const rows = selectedData?.map((row, index) =>
    headersConfig.map((header) => {
      return header.render
        ? header.render(null, row, index)
        : row[header.key] || "-";
    })
  );
  doc.autoTable({
    startY: headerBottomY + 6,
    head: headers,
    body: rows,
    theme: "grid",
    headStyles: {
      fillColor: "#124699",
      textColor: "#fff",
      fontStyle: "bold",
      cellPadding: 5,
    },
    bodyStyles: {
      fillColor: "#f5f5f5",
      textColor: "#000",
      fontSize: 10,
      cellPadding: 4,
    },
    alternateRowStyles: {
      fillColor: "#fff",
    },
    margin: { left: leftMargin, right: rightMargin },
    pageBreak: "auto",
    didDrawPage: (data) => {
      const footerY = doc.internal.pageSize.height - bottomMargin;
      doc.setFontSize(10);
      doc.text("Email: ask@bharatexamfest.com", leftMargin, footerY);

      const poweredByText = "Powered By: HK Digiverse & IT Consultancy";
      doc.text(poweredByText, pageWidth - rightMargin, footerY, {
        align: "right",
      });
      const poweredByX =
        pageWidth - rightMargin - doc.getTextWidth(poweredByText);
      doc.link(poweredByX, footerY - 2, doc.getTextWidth(poweredByText), 10, {
        url: "https://hkdigiverse.com/",
      });
      const pageCount = doc.internal.getNumberOfPages();
      doc.text(`${pageCount}`, pageWidth / 2, footerY, { align: "center" });
    },
  });
  doc.save(pdfName || "exported_table.pdf");
};
export const exportToTableCSV = ({
  data,
  selectedStudents,
  headersConfig,
  csvName,
}) => {
  const selectedData =
    selectedStudents && selectedStudents?.length > 0
      ? data.filter((row) => selectedStudents.includes(row._id))
      : data;

  if (selectedData.length === 0) {
    toast.warn("No data selected for export!", {
      autoClose: 2000,
      pauseOnHover: false,
    });
    return;
  }

  const headers = headersConfig.map((header) => header.label);
  const rows = selectedData.map((row, index) =>
    headersConfig.map((header) => {
      return header.render
        ? header.render(null, row, index)
        : row[header.key] || "-";
    })
  );

  let csvContent = "data:text/csv;charset=utf-8,";

  csvContent += headers.join(",") + "\n";

  rows.forEach((row) => {
    csvContent += row.join(",") + "\n";
  });

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", csvName || "exported_table.csv");
  document.body.appendChild(link);
  link.click();
};

export const generatePDF = (htmlContent, pdfName) => {
  const tempDiv = document.createElement("div");
  tempDiv.id = "tempEditorContainer";
  tempDiv.style.position = "absolute";
  tempDiv.style.left = "-9999px";
  tempDiv.innerHTML = htmlContent;
  tempDiv.style.fontSize = "20px";
  tempDiv.style.fontFamily = "Arial, sans-serif";
  const allElements = tempDiv.querySelectorAll("*");
  allElements.forEach((element) => {
    element.style.fontSize = "20px";
    element.style.fontFamily = "Arial, sans-serif";
  });
  document.body.appendChild(tempDiv);
  html2canvas(tempDiv, {
    onclone: (document) => {
      const clonedDiv = document.getElementById("tempEditorContainer");
      if (clonedDiv) {
        clonedDiv.style.fontSize = "20px";
        const clonedElements = clonedDiv.querySelectorAll("*");
        clonedElements.forEach((element) => {
          element.style.fontSize = "20px";
          element.style.fontFamily = "Arial, sans-serif";
        });
      }
    },
  })
    .then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();

      const pageWidth = pdf.internal.pageSize.width;
      const pageHeight = pdf.internal.pageSize.height;

      const topMargin = 10;
      const leftMargin = 10;
      const rightMargin = 10;
      const bottomMargin = 10;

      const { headerBottomY, footerTopY } = generateCommonHeaderAndFooter(
        pdf,
        pageWidth,
        topMargin,
        leftMargin,
        rightMargin,
        bottomMargin
      );

      const imgWidth = pageWidth - leftMargin - rightMargin;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = headerBottomY + 10;

      pdf.setFontSize(20);
      pdf.setFont("helvetica", "normal");

      while (heightLeft > 0) {
        if (position + imgHeight > footerTopY) {
          pdf.addPage();
          position = headerBottomY + 10;
          generateCommonHeaderAndFooter(
            pdf,
            pageWidth,
            topMargin,
            leftMargin,
            rightMargin,
            bottomMargin
          );
        }

        pdf.addImage(
          imgData,
          "JPEG",
          leftMargin,
          position,
          imgWidth,
          imgHeight
        );
        heightLeft -= pageHeight - bottomMargin - headerBottomY - 10;
      }

      pdf.save(pdfName);
    })
    .catch((error) => {})
    .finally(() => {
      document.body.removeChild(tempDiv);
    });
};

export const onExportkycDetails = (kycDataArray) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const margin = 8;

  kycDataArray.forEach((kycData, index) => {
    const { headerBottomY } = generateCommonHeaderAndFooter(
      doc,
      pageWidth,
      margin,
      margin,
      margin,
      margin
    );

    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.text(`KYC Details`, pageWidth / 2, headerBottomY, { align: "center" });
    const tableData = [
      [
        "Name",
        `${kycData?.user?.firstName || ""} ${kycData?.user?.lastName || ""}`,
      ],
      [
        "Phone",
        kycData?.user?.contact?.mobile
          ? `${kycData?.user?.contact?.countryCode} ${kycData?.user?.contact?.mobile}`
          : "-",
      ],
      ["Email", kycData?.user?.email || "-"],
      ["Proof Type", kycData?.idProof || "-"],
      ["Proof Number", kycData?.idNumber || "-"],
      [
        "DOB",
        kycData?.user?.dob ? convertUtcToIstDateOnly(kycData?.user?.dob) : "-",
      ],
      ["Gender", kycData?.user?.gender || "-"],
      ["City", kycData?.user?.city || "-"],
      ["Status", kycData?.status || "-"],
      ["Front Side Image", kycData?.frontSideImage || "-"],
      ["Back Side Image", kycData?.frontSideImage || "-"],
    ];
    doc.autoTable({
      startY: headerBottomY + 10,
      head: [["Field", "Value"]],
      body: tableData,
      theme: "grid",
      headStyles: {
        fillColor: "#124699",
        textColor: "#fff",
        fontStyle: "bold",
        cellPadding: 5,
      },
      bodyStyles: {
        fillColor: "#f5f5f5",
        textColor: "#000",
        fontSize: 10,
        cellPadding: 4,
      },
      alternateRowStyles: {
        fillColor: "#fff",
      },
      margin: { top: 10, left: margin, right: margin },
    });

    if (index < kycDataArray.length - 1) {
      doc.addPage();
    }
  });

  doc.save("kyc_details.pdf");
};
